// extracted by css-extract-rspack-plugin
module.exports =  {"zoomable":"W8fj7","zoomBtnWrap":"doIHR","zoomIn":"k4och","zoomOut":"o5Sq9","reset":"uJybT","layer":"U9MUr"};